import React, { useRef, useEffect } from 'react';

import classes from './Pie.module.css'
import { wait } from '../../../../utils';

const Pie =({val, color})=>{
   const canvasRef = useRef();
    useEffect(async()  => {
        let c, ctx, x, y, newValue;
                const drawArc = async (value) => {
                    ctx.clearRect(0, 0, c.width, c.height);
                    ctx.beginPath();
                    ctx.arc(x, y, 50, 0.6 * Math.PI, (0.6 + (value / 100 * 1.8)) * Math.PI);
                    ctx.stroke();
                    if (value < val) {
                        await wait(2);
                        await drawArc(value + 1);
                    } else {
                        ctx.beginPath();
                        ctx.arc(x, y, 50, 0.6 * Math.PI, (0.6 + (val / 100 * 1.8)) * Math.PI);
                        ctx.stroke();
                    }
                }
        
                c = canvasRef.current;
                ctx = c.getContext("2d");
                ctx.strokeStyle = color;
                ctx.lineWidth = 13;
                x = c.width / 2;
                y = c.height / 2;
                await drawArc(1);
        
                ctx.beginPath();
                ctx.strokeStyle = "#ededed";
                ctx.arc(x, y, 50, 0.6 * Math.PI, 0.4 * Math.PI);
                ctx.stroke();
        
                ctx.beginPath();
                ctx.strokeStyle = color;
                ctx.arc(x, y, 50, 0.6 * Math.PI, (0.6 + (val / 100 * 1.8)) * Math.PI);
                ctx.stroke();
      }, [val])

        return (
            <div className={classes.Pie}>
                <canvas ref={canvasRef} width="200" height="180"></canvas>
                <div className={classes.Num}>{val}%</div>
            </div >
        )
    }
export default Pie